import CrudErrors from "../CrudErros";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";

const ServiceCrudForm = ({setForm, form, createData, updateData, groups, handleReset, errors}) => {
    let myAbi = HelpAbility();

    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    }

    const handleCode = (e) => {
        if (!(/\s/.test(e.target.value))) {
           setForm({...form, [e.target.name]: e.target.value});
        }
        
    }

    const handleChangeBool = (e) => {
        setForm({...form, [e.target.name]: e.target.value === 'true'});
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (form._id === null) {
            createData(form);
        } else {
            updateData(form);
        }
    }

    const isVisibleForm = () => (form._id === null) ? myAbi.has(C.A.SERVICE.CREATE) : myAbi.has(C.A.SERVICE.UPDATE);

    return (
        <>
            {isVisibleForm() && <>
                <h3 className="text-center">{form._id ? 'Editar' : 'Agregar'} Servicio</h3>
                {errors && <CrudErrors errors={errors}/>}
                <div className="mb-3">
                    <label htmlFor="code" className="form-label">Código</label>
                    <input type="text" className="form-control" id="code" name="code" autoComplete="off"
                           disabled={!!form._id}
                           value={form.code} onChange={handleCode}/>
                    <div id="codeHelp" className="form-text">El código debe ser único</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Nombre</label>
                    <input type="text" className="form-control" id="name" name="name" value={form.name}
                           autoComplete="off"
                           onChange={handleChange}/>
                </div>
                <div className="mb-3">
                    <label htmlFor="endpoint" className="form-label">Endpoint</label>
                    <input type="text" className="form-control" id="endpoint" name="endpoint" value={form.endpoint}
                        autoComplete="off" onChange={handleChange}/>
                </div>
                <div className="mb-3">
                    <label htmlFor="description" className="form-label">Descripción</label>
                    <textarea className="form-control" id="description" name="description" value={form.description}
                        onChange={handleChange}/>
                </div>

                <div className="mb-3">
                    <label className="form-label">Grupo</label>
                    <div className="form-check">
                        {groups.map((group) => (
                        <div key={group.code} className="form-check">
                        <input
                        className="form-check-input"
                        type="checkbox"
                        id={`group-${group.code}`}
                        name="groupCodes"
                        value={group.code} // <- valor correcto
                        checked={form.groupCodes.includes(group.code)} // <- comparar con code, no name
                        onChange={(e) => {
                            const { checked, value } = e.target;
                            setForm((prevForm) => {
                            const updated = checked
                                ? [...prevForm.groupCodes, value]
                                : prevForm.groupCodes.filter((v) => v !== value);
                            return {
                                ...prevForm,
                                groupCodes: updated,
                            };
                            });
                        }}
                        />
                            <label className="form-check-label" htmlFor={`group-${group.code}`}>
                            {group.code} - {group.name}
                            </label>
                        </div>
                        ))}
                    </div>
                </div>

                <div className="mb-3">
                    <label htmlFor="responseByDefault" className="form-label">Respuesta por Defecto: &nbsp;</label>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="responseByDefault" onChange={handleChangeBool}
                            checked={form.responseByDefault === true} id="responseByDefault-radio-true" value={true}/>
                        <label className="form-check-label" htmlFor="responseByDefault-radio-true">Si</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="responseByDefault" onChange={handleChangeBool}
                            checked={form.responseByDefault === false} id="responseByDefault-radio-false" value={false}/>
                        <label className="form-check-label" htmlFor="responseByDefault-radio-false">No</label>
                    </div>
                </div>
                <div className="mb-3">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="isVisible" onChange={handleChangeBool}
                            checked={form.isVisible === true} id="isVisible-radio-true" value={true}/>
                        <label className="form-check-label" htmlFor="isVisible-radio-true">Visible</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="isVisible" onChange={handleChangeBool}
                            checked={form.isVisible === false} id="isVisible-radio-false" value={false}/>
                        <label className="form-check-label" htmlFor="isVisible-radio-false">No Visible</label>
                    </div>
                </div>
                <button type="submit" className="btn btn-primary me-2" onClick={handleSubmit}><i
                    className="bi bi-save"/> Guardar
                </button>
                <button type="reset" className="btn btn-secondary" onClick={handleReset}><i
                    className="bi bi-eraser"/> Limpiar
                </button>
            </>}
        </>
    );
}
export default ServiceCrudForm;
